import { type Instacart_Types_V1_MeasuredQuantity } from '../../../api'
import { type MeasuredQuantity } from './types'

export function mapMeasuredQuantity(
  measuredQuantity: Instacart_Types_V1_MeasuredQuantity
): MeasuredQuantity {
  return {
    quantity: measuredQuantity.quantity!,
    unit: {
      unitCode: measuredQuantity.unit!.unitCode!,
      costUnit: measuredQuantity.unit!.costUnit!,
    },
  }
}
